
 <div class="full-page">
   <div class="flex justify-content-center py-4 bg">
        <img src="assets/images/LincSell-Main.svg" width="150px" alt="Lincsell">
      </div>

     <div class="payment-success-container">
        <div class="payment-box">
            <div class="flex justify-content-center p-4 flex-column align-items-center ">
                <div class="flex justify-content-center my-1">
                    <img src="assets/images/Verification.png" />
                </div>

            </div>
          <h1>Payment Successful!</h1>
          <p class="payment-text">
            Your payment of <strong>{{ totalAmount | currency | currencyDisplay }}</strong> was successfully processed.
            <br />
            Thank you for joining LincSell â€“ weâ€™re excited to power your business!
          </p>
          <p class="subtext">Login to your business dashboard & setup your online store.</p>
          <button class="dashboard-btn" (click)="lanchDashboard()">Launch Dashboard</button>
        </div>
      </div>
 </div>






